(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boo-spider-cart"] && !Shopify.designMode) return;
  try {
    function initBooSpider() {
    const spider = document.querySelector('[data-boo-spider]');
    if (!spider || spider.dataset.ready) return;
    spider.dataset.ready = 'true';
    const shortcut = spider.querySelector('a');
    const trigger = document.querySelector('.boo-header [data-testid="cart-drawer-trigger"]');
    const mobile = matchMedia('(max-width: 989px)');
    let slot;
    if (trigger) {
      slot = document.createElement('span');
      slot.className = 'boo-spider__slot';
      slot.setAttribute('aria-hidden', 'true');
      trigger.before(slot);
      trigger.classList.add('boo-mobile-cart');
    }
    let pending = false;
    const wrapper = document.querySelector('.page-wrapper');
    const getScrollHost = () => wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement;
    let origin = { x: 0, y: 0, anchor: 0 };
    const measure = () => {
      if (mobile.matches && slot) {
        const rect = slot.getBoundingClientRect();
        const offset = scrollY + (wrapper?.scrollTop || 0);
        const announcement = document.querySelector('.boo-announcement');
        origin = { x: rect.x, y: rect.y + offset, anchor: announcement ? announcement.getBoundingClientRect().bottom + offset : 0 };
        spider.style.setProperty('--spider-x', origin.x + 'px');
        trigger.style.setProperty('--spider-x', origin.x + 'px');
        trigger.style.setProperty('--spider-start', origin.y + 'px');
        spider.setAttribute('data-mobile-ready', '');
      } else {
        spider.removeAttribute('data-mobile-ready');
      }
    };
    const position = () => {
      const scrollHost = getScrollHost();
      const range = Math.max(1, scrollHost.scrollHeight - scrollHost.clientHeight);
      const progress = Math.min(1, Math.max(0, scrollHost.scrollTop / range));
      if (mobile.matches && trigger) {
        const travel = progress * Math.max(0, innerHeight - origin.y - 154);
        const anchor = Math.max(0, origin.anchor - scrollY - (wrapper?.scrollTop || 0));
        trigger.style.setProperty('--spider-travel', travel + 'px');
        spider.style.setProperty('--spider-anchor', anchor + 'px');
        spider.style.setProperty('--spider-drop', Math.max(0, origin.y + travel + 14 - anchor) + 'px');
        pending = false;
        return;
      }
      const y = 155 + progress * Math.min(150, Math.max(0, innerHeight - 280));
      spider.style.setProperty('--spider-y', y + 'px');
      pending = false;
    };
    const update = () => { if (!pending) { pending = true; requestAnimationFrame(position); } };
    wrapper?.addEventListener('scroll', update, { passive: true });
    addEventListener('scroll', update, { passive: true });
    document.addEventListener('boo:filters:change', update);
    const resize = () => { measure(); update(); };
    addEventListener('resize', resize, { passive: true });
    mobile.addEventListener('change', resize);
    const header = document.querySelector('.boo-header');
    if (header) new ResizeObserver(resize).observe(header);
    shortcut.addEventListener('click', (event) => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) { event.preventDefault(); trigger.click(); }
    });
    const source = document.querySelector('cart-icon');
    const badge = spider.querySelector('[data-boo-count]');
    const syncCount = () => {
      const raw = source?.querySelector('[ref="cartBubbleCount"]')?.textContent?.trim() || '0';
      badge.textContent = raw;
      badge.hidden = raw === '0' || raw === '';
    };
    if (source) new MutationObserver(syncCount).observe(source, { subtree: true, childList: true, characterData: true, attributes: true });
    syncCount();
    measure();
    position();
  }
  initBooSpider();
  document.addEventListener('shopify:section:load', initBooSpider);
  } catch(e) { console.error(e); }
})();

})();
